import { TextField as MaterialUiTextField } from '@mui/material'
import { BaseTextFieldProps } from './BaseTextField.types'

import './BaseTextField.scss'

const TextField: React.FC<BaseTextFieldProps> = ({
	id,
	label,
	minRows,
	value,
	type,
	onChange,
	sx,
	...props
}): JSX.Element => {
	return (
		<MaterialUiTextField
			id={id}
			className='base-textfield'
			label={label}
			multiline={true}
			type={type}
			minRows={minRows}
			value={value}
			name={id}
			sx={sx}
			onChange={onChange}
			{...props}
		/>
	)
}

export default TextField
